var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgContactRecord = function SvgContactRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3a3 3 0 0 1 3-3h34a3 3 0 0 1 3 3v34a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z",
    fill: "#A094ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.12 12.02H10.88A2.287 2.287 0 0 0 8.6 14.3v11.02a2.287 2.287 0 0 0 2.28 2.28h18.24a2.287 2.287 0 0 0 2.28-2.28V14.3a2.287 2.287 0 0 0-2.28-2.28Zm-9.652 12.92h-6.536c-.722 0-1.292-.798-1.292-1.558.038-1.14 1.216-1.824 2.47-2.394.874-.38.988-.722.988-1.102 0-.38-.228-.722-.532-.988-.494-.456-.798-1.14-.798-1.9 0-1.444.874-2.66 2.394-2.66s2.394 1.216 2.394 2.66c0 .76-.266 1.444-.798 1.9-.304.266-.532.608-.532.988s.114.722.988 1.064c1.254.532 2.432 1.292 2.47 2.432.076.76-.494 1.558-1.216 1.558Zm8.892-2.66c0 .418-.342.76-.76.76h-3.42a.762.762 0 0 1-.76-.76v-1.14c0-.418.342-.76.76-.76h3.42c.418 0 .76.342.76.76v1.14Zm0-4.18c0 .418-.342.76-.76.76h-5.7a.762.762 0 0 1-.76-.76v-1.14c0-.418.342-.76.76-.76h5.7c.418 0 .76.342.76.76v1.14Z",
    fill: "#fff"
  })));
};

export default SvgContactRecord;